import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FontProperty} from '../../../user/model/FontProperty';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-add-font-property',
  templateUrl: './add-font-property.component.html',
  styleUrls: ['./add-font-property.component.css']
})
export class AddFontPropertyComponent implements OnInit {
  @Input() element: any;
  @Input() fontProperty: FontProperty;
  public color = 'rgba(0,0,0,1)';
  fontSizes: any[] = [];
  @Output() saveFontProperty = new EventEmitter<string>();

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.fontSizes = LocalStorage.getFontsizes();
    this.fontProperty.fontFamily = this.fontProperty.fontFamily ? this.fontProperty.fontFamily : 'Helvetica';
    this.fontProperty.fontSize = this.fontProperty.fontSize ? this.fontProperty.fontSize : '11px';
    this.fontProperty.textDecoration = this.fontProperty.textDecoration !== '' ? this.fontProperty.textDecoration : this.fontDecorations[0].value;
    if (!this.fontProperty.color) {
      this.fontProperty.color = 'rgba(0,0,0,1)';
    }
  }

  accept() {
    this.fontProperty.content = this.fontProperty.content.trim();
    // @ts-ignore
    this.saveFontProperty.emit(this.fontProperty);
  }

  colorPickerChange(rgbColor: string) {
    this.fontProperty.color = rgbColor;
    // this.color = rgbColor;
  }

  backgroundColorPickerChange(rgbColor: string) {
    this.fontProperty.backgroundColor = rgbColor;
    // this.color = rgbColor;
  }

  get fontDecorations() {
    return [{value: 'none', view: 'None'},
      {value: 'overline', view: 'Overline'},
      {value: 'line-through', view: 'Line-through'},
      {value: 'underline', view: 'Underline'},
      {value: 'underline overline', view: 'Underline overline'}
    ];
  }

  get fontWeights() {
    return [{value: 'normal', view: 'Normal'},
      {value: 'initial', view: 'Initial'},
      {value: 'unset', view: 'Unset'},
      {value: 'bold', view: 'Bold'},
      {value: 'revert', view: 'Revert'},
      {value: 'bolder', view: 'Bolder'},
      {value: 'lighter', view: 'Lighter'}
    ];
  }

  get fontTypes() {
    return [{value: 'Helvetica', view: 'Helvetica'},
      {value: 'Arial', view: 'Arial'},
      // {value: 'Arial black', view: 'Arial black'},
      {value: 'SansSerif', view: 'SansSerif'},
      // {value: 'cursive', view: 'Cursive'},
      // {value: 'fantasy', view: 'Fantasy'},
      {value: 'courier, arial, helvetica', view: 'Courier, Arial, Helvetica'},
      {value: 'Roboto', view: 'Roboto'}
    ];
  }

  get alignTexts() {
    return [{value: 'left', view: 'Left'},
      {value: 'center', view: 'Center'},
      {value: 'right', view: 'Right'},
      {value: 'justify', view: 'Justify'},
      {value: 'justify-all', view: 'Justify-all'},
    ];
  }
}
